import axios from 'axios';
const KEY = 'AIzaSyCLUux4_BznG6SrSL5NfQAgENc0uhjXs4s'; // mention your youtube API key here

export default axios.create({
	baseURL: 'https://www.googleapis.com/youtube/v3/',
	params: {
		part: 'snippet',
		maxResults: 3,
		key: KEY
	}
})